import { PiPersonSimpleBike, PiPersonSimpleBikeFill, PiCirclesFour, PiCirclesFourFill, PiSparkle, PiSparkleFill, PiUsersFour, PiUserList, PiUserListFill,  } from "react-icons/pi";
import { IoSettingsSharp } from "react-icons/io5";
import { FiSettings } from "react-icons/fi";
import { PiBowlFood, PiBowlFoodFill, PiUsersFourLight } from "react-icons/pi";
import { PiUsersFourFill } from "react-icons/pi";
import { Link, useLocation } from "react-router-dom";
import userImage from '../../assets/images/Image.png'
import { MdOutlineLogout } from "react-icons/md";
import Warning from '../../assets/images/WarningOctagon.png'
import Logo from '../../assets/images/FESPRIS KITCHEN MAIN LOGO.png'
import CloseModal from '../../assets/images/XCircle.png'
import { FaCircleCheck } from "react-icons/fa6";
import { BsBoxSeam, BsBoxSeamFill } from "react-icons/bs";
import { useEffect, useState } from 'react';
import { fetchUsers } from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";


 export const SidebarData = [
  {
    title: "Overview",
    path: "/overview",
    icon: <PiCirclesFour />,
    icon2: <PiCirclesFourFill />,
  },
  {
    title: "Food Menu",
    path: "/category",
    icon: <PiBowlFood />,
    icon2: <PiBowlFoodFill />,
  },
  {
    title: "Orders",
    path: "/orders",
    icon: <BsBoxSeam className="bg-transparent" />,
    icon2: <BsBoxSeamFill />,
  },
  {
    title: "Customers",
    path: "/customers",
    icon: <PiUsersFourLight />,
    icon2: <PiUsersFourFill/>,
  },
  {
    title: "Delivery Agent",
    path: "/delivery-agents",
    icon: <PiPersonSimpleBike />,
    icon2: <PiPersonSimpleBikeFill />,
  },
  {
    title: "Ratings & Reviews",
    path: "/ratings",
    icon: <PiSparkle />,
    icon2: <PiSparkleFill />,
  },
  {
    title: "Complaints ",
    path: "/complaints",
    icon: <PiUserList />,
    icon2: <PiUserListFill />,
  },
  {
    title: "Settings",
    path: "/settings",
    icon: <FiSettings />,
    icon2: <IoSettingsSharp />,
  },
];
const SideBar = () => {

  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [imageFile, setImageFile] = useState('')

  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth);

  useEffect(() =>{
    dispatch(fetchUsers())
  }, [dispatch]);

  const userProfile = user?.user?.data?.profile;
  console.log(userProfile);

  useEffect(() => {
    if (userProfile?.profileImage?.length > 0) {
      setImageFile(userProfile?.profileImage);
    }
  }, [userProfile]);

    const pathMatchRoute = (route) => {
        if (route === location.pathname) {
            return true
        }
    }

    const handleClick = () => {
      setOpen(prev => !prev);
    };
  

    return (
        <nav className="hidden lg:flex bg-primaryBrown w-64">
          <div className="fixed z-[100] left-0 top-0 bg-primaryBrown w-64 py-6">
            <img src={Logo} alt="logo" className="" />
          </div>
          <div className="mt-48 w-64 flex flex-col">
              <ul className="pt-3 flex-grow">
                {SidebarData.map((item, index) => {
                  return (
                    <div
                      key={index}
                      >
                      <Link
                        key={index}
                        to={item.path}
                        className="text-white"
                      >
                        <li
                          className={`${pathMatchRoute(item.path) ? "bg-white border-r-[8px] rounded-tr-md rounded-br-md border-r-primaryRed font-semibold text-primaryRed" : "hover:bg-red-700/20 hover:bg-blur"} pl-5 py-2 my-3 flex items-center gap-x-5`}
                        >
                          <span className="text-2xl">{pathMatchRoute(item.path)  ? item.icon2 : item.icon}</span>
                          <span className="ml-2 py-1 mr-6 text-md whitespace-nowrap">{item.title}</span>
                        </li>
                      </Link>
                    </div>
                  );
                })}
              </ul>
              <div className="bg-orange ml-4 mr-2 mt-6 mb-10 rounded-md px-2">
                <div className="px-2 py-3 flex items-center">
                <div className="">
                  {imageFile ? (
                    <div className="relative">
                      <img
                        src={imageFile}
                        alt="Selected"
                        className={` w-10 h-10 rounded-full object-cover`}
                      />
                      <FaCircleCheck className="absolute bottom-0 right-0 text-orange border rounded-full border-primaryRed text-xl" />
                    </div>
                    ) : (
                      <div className="relative">
                        <img src={userImage} alt="profile-image" className="h-10 w-10" />
                        <FaCircleCheck className="absolute bottom-0 right-0 text-orange border rounded-full border-primaryRed text-xl" />
                      </div>
                  )}
                 </div>
                  <div className="mx-3 text-sm">
                    <p className="mb-1 font-semibold">{userProfile?.userName}</p>
                    <p className="">{userProfile?.roleName}</p>
                  </div>
                  {/* logout alert dialog */}
                  <div>
                    <MdOutlineLogout className="text-primaryRed text-2xl cursor-pointer" onClick={handleClick} />
                    {open &&
                      <div className="fixed inset-0 bg-orange/20 backdrop-blur-[1px] grid place-items-center z-[100]">
                        <div className='relative bg-white rounded-2xl py-5 px-4 max-w-sm'>
                          <button 
                            className="absolute top-6 right-5"
                            onClick={handleClick}
                          >
                            <img src={CloseModal} alt="" className='' />
                          </button>
                          <div className="mt-5 flex justify-center rounded-full">
                            <img src={Warning} alt="" className='bg-[#eec4c4] rounded-full' />
                          </div>
                          <div className='mt-7'>
                            <h2 className="text-[28px] font-extrabold text-primaryRed text-center capitalize">confirm log out</h2>
                            <div>
                              <p class="text-center py-4">
                                Are you sure you want to log out? Any unsaved changes will be lost.
                              </p>
                            </div>
                            <div className='flex items-center justify-center gap-x-6 mt-5 '>
                              <button className="text-primaryRed border border-[#FFB0B0] px-6 py-2 text-center rounded-md w-full hover:bg-[#FFB0B0]" onClick={handleClick}>Cancel</button>
                              <Link className="text-white border border-primryRed bg-primaryRed px-6 py-2 text-center rounded-md hover:bg-primaryRed/80 w-full" to='/' onClick={handleClick} autoFocus>
                                Logout
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
          </div>


        </nav>
  );
};
export default SideBar;
